import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import moment from 'moment'

import { HOUR_MIN, HOUR_MIN_SECOND } from 'src/constants/app'
import { roundingDownMinutes, roundingUpMinutes } from 'src/utils/helper'
import { PATH } from 'src/pages/video'
import videoDoctorFreeTime from 'src/store/domain/video/doctorFreeTime'
import videoWorkingDate from 'src/store/domain/video/workingDate'
import videoRequest from 'src/api/requests/video'
import reservationReq from 'src/api/requests/reservation'
import videoAppointmentAction from 'src/store/domain/video/videoAppointment'
import history from 'src/libs/history'
import LocalStorage from 'src/utils/LocalStorage'

export interface paramsBusyTime {
  params: { date: string }
}

export interface paramsWorkingDates {
  params: {}
}

export interface GetVideoAppointment {
  token: string | undefined
}

export interface dateSchedule {
  date: string
}

export const busyTime = createAsyncThunk<any, paramsBusyTime>(
  'get_busy_time',
  async ({ params }, { dispatch }) => {
    try {
      dispatch(videoDoctorFreeTime.updateLoading(true))
      const res = await videoRequest.busyTime(params)
      if (res.data) {
        let optionTimes: Response.optionDoctorFreeTime[] = []
        res.data &&
          _.forEach(res.data.doctor_shift_with_date, (item) => {
            let startTime = roundingUpMinutes(
              moment(item.start_time, HOUR_MIN_SECOND),
            )
            let endTime = roundingDownMinutes(
              moment(item.end_time, HOUR_MIN_SECOND),
            )
            while (startTime < endTime) {
              const timeFrom = startTime.format(HOUR_MIN)
              const hour = timeFrom.split(':')
              const convertTimeFrom = Number(hour[0]) * 60 + Number(hour[1])

              const currentTime = new Date()
              const convertCurrentTime =
                currentTime.getHours() * 60 + currentTime.getMinutes()
              const timeTo = startTime.add(30, 'minutes').format(HOUR_MIN)
              if (
                !_.includes(
                  _.map(
                    res.data.doctor_busy_time_with_date,
                    'reservation_time',
                  ),
                  timeFrom,
                ) &&
                (convertTimeFrom > convertCurrentTime ||
                  moment(item.date).isAfter(moment()))
              ) {
                optionTimes.push({
                  value: timeFrom,
                  label: `${timeFrom} - ${timeTo}`,
                })
              }
            }
          })
        dispatch(videoDoctorFreeTime.updateEntity(optionTimes))
      }
      dispatch(videoDoctorFreeTime.updateLoading(false))
    } catch (error) {
      dispatch(videoDoctorFreeTime.updateLoading(false))
    }
  },
)

export const setBusyTime = createAsyncThunk<any, any>(
  'reset_busy_time',
  async (data, { dispatch }) => {
    dispatch(videoDoctorFreeTime.updateEntity(data))
  },
)

export const getWorkingDates = createAsyncThunk<any, paramsWorkingDates>(
  'get_working_dates',
  async ({ params }, { dispatch }) => {
    try {
      dispatch(videoWorkingDate.updateLoading(true))
      const res = await videoRequest.getWorkingDates(params)
      if (res.data) {
        dispatch(videoWorkingDate.updateEntity(res.data.data))
      }
      dispatch(videoWorkingDate.updateLoading(false))
    } catch (error) {
      dispatch(videoWorkingDate.updateLoading(false))
    }
  },
)

export const videoAppointment = createAsyncThunk<any, GetVideoAppointment>(
  'get_video_appointment',
  async ({ token }, { dispatch }) => {
    try {
      dispatch(videoAppointmentAction.updateLoading(true))
      const res = await reservationReq.getVideoAppointment(token)
      if (res.data) {
        dispatch(videoAppointmentAction.updateEntity(res.data))
      }
      const agoraOutcome = await reservationReq.getAgoraToken()
      dispatch(
        videoAppointmentAction.updateAgoraChannel(agoraOutcome.data.data),
      )
      dispatch(videoAppointmentAction.updateLoading(false))
    } catch (error) {
      const msg = _.get(error, 'response.data.message', '')
      dispatch(videoAppointmentAction.updateLoading(false))
      dispatch(videoAppointmentAction.updateErrorMsg(msg))
      history.push(PATH.NOT_ALLOWED)
    }
  },
)

export const endVideoCall = createAsyncThunk<any>(
  'end_video_call',
  async (any, { dispatch }) => {
    try {
      await reservationReq.endVideoCall()
      history.push(PATH.THANK)
    } catch (error) {
      const msg = _.get(error, 'response.data.message', '')
      dispatch(videoAppointmentAction.updateLoading(false))
      dispatch(videoAppointmentAction.updateErrorMsg(msg))
      history.push(PATH.NOT_ALLOWED)
    }
  },
)

export const createReservationDate = async (data: dateSchedule) => {
  try {
    const userTreatmentId = LocalStorage.getUserTreatmentId()

    await videoRequest.createReservationDate({
      ...data,
      ...{ user_treatment_id: userTreatmentId },
    })

    return true
  } catch (error) {
    return false
  }
}

export const refreshVideoToken = async () => {
  try {
    const agoraOutcome = await reservationReq.getAgoraToken()
    return agoraOutcome.data.data.token
  } catch (error) {
    return null
  }
}
